import { useCart } from '../contexts/CartContext'
import { useState } from 'react'
import { createPaymentIntent } from '../utils/stripe'

function CheckoutPage() {
  const { 
    items, 
    getCartTotals, 
    shippingOption, 
    shippingAddress, 
    billingAddress,
    setShippingAddress,
    setBillingAddress
  } = useCart()
  const totals = getCartTotals()

  const [useSameAddress, setUseSameAddress] = useState(true)
  const [shippingForm, setShippingForm] = useState(shippingAddress)
  const [billingForm, setBillingForm] = useState(billingAddress)
  const [billingEmail, setBillingEmail] = useState('')
  const [emailError, setEmailError] = useState('')

  const handleStripeCheckout = async () => {
    try {
      const email = billingEmail.trim()
      const emailOk = /.+@.+\..+/.test(email)
      if (!emailOk) {
        setEmailError('Valid email required')
        return
      }
      setEmailError('')
      const amount = Number(String(totals.total).replace(/[^0-9.]/g, ''))
      const result = await createPaymentIntent(Math.round(amount * 100), email)
      // Placeholder: in real integration, pass clientSecret to Stripe.js
      console.log('Stripe clientSecret:', result.clientSecret)
      alert('Stripe integration coming soon. Payment intent created successfully.')
    } catch (e) {
      console.error(e)
      alert('Unable to start payment. Please try again soon.')
    }
  }

  return (
    <div className="checkout-page">
      <div className="container">
        <h1 className="cart-title">Checkout</h1>

        <div className="cart-content">
          <div className="checkout-forms">
            <div className="checkout-card">
              <h3>Shipping Method</h3>
              <div className="shipping-method-display" style={{ marginTop: '0.5rem' }}>
                {shippingOption === 'pickup' && (
                  <div className="shipping-method-item selected">
                    <strong>Local Pickup</strong>
                    <small>Free - within 20 miles of store</small>
                  </div>
                )}
                {shippingOption === 'delivery' && (
                  <div className="shipping-method-item selected">
                    <strong>Local Delivery</strong>
                  </div>
                )}
                {shippingOption === 'shipping' && (
                  <div className="shipping-method-item selected">
                    <strong>Standard Shipping</strong>
                    <small>$8.00 - standard shipping</small>
                  </div>
                )}
              </div>
              {shippingOption === 'delivery' && (() => {
                const addr = (shippingAddress && (shippingAddress.address1 || shippingAddress.fullName)) ? shippingAddress : shippingForm
                if (!addr || !(addr.address1 || addr.fullName || addr.city || addr.state || addr.zip)) return null
                return (
                  <div className="address-display" style={{ marginTop: '0.75rem', color: '#374151' }}>
                    {addr.fullName && <div><strong>{addr.fullName}</strong></div>}
                    {addr.address1 && <div>{addr.address1}</div>}
                    {addr.address2 && <div>{addr.address2}</div>}
                    {(addr.city || addr.state || addr.zip) && (
                      <div>{addr.city || ''}{addr.state ? `, ${addr.state}` : ''} {addr.zip || ''}</div>
                    )}
                  </div>
                )
              })()}
              {shippingOption !== 'pickup' && (
                <div className="summary-line" style={{ marginTop: '0.75rem' }}>
                  <span>Shipping Cost:</span>
                  <span>${totals.shipping}</span>
                </div>
              )}
            </div>

            {shippingOption === 'shipping' && (
              <section className="checkout-section" style={{ display: 'none' }}>
                <h3>Shipping Address</h3>
              <div className="address-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="shipping_fullName">Full Name</label>
                    <input
                      id="shipping_fullName"
                      type="text"
                      value={shippingForm.fullName}
                      onChange={(e) => setShippingForm({ ...shippingForm, fullName: e.target.value })}
                      placeholder="John Doe"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="shipping_address1">Address</label>
                    <input
                      id="shipping_address1"
                      type="text"
                      value={shippingForm.address1}
                      onChange={(e) => setShippingForm({ ...shippingForm, address1: e.target.value })}
                      placeholder="123 Main St"
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="shipping_address2">Apt, suite, etc. (optional)</label>
                    <input
                      id="shipping_address2"
                      type="text"
                      value={shippingForm.address2}
                      onChange={(e) => setShippingForm({ ...shippingForm, address2: e.target.value })}
                      placeholder="Apt 4B"
                    />
                  </div>
                </div>
                <div className="form-row two-col">
                  <div className="form-group">
                    <label htmlFor="shipping_city">City</label>
                    <input
                      id="shipping_city"
                      type="text"
                      value={shippingForm.city}
                      onChange={(e) => setShippingForm({ ...shippingForm, city: e.target.value })}
                      placeholder="Lubbock"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="shipping_state">State</label>
                    <select
                      id="shipping_state"
                      value={shippingForm.state}
                      onChange={(e) => setShippingForm({ ...shippingForm, state: e.target.value })}
                    >
                      <option value="">Select</option>
                      <option value="TX">TX</option>
                      <option value="NM">NM</option>
                      <option value="OK">OK</option>
                      <option value="CO">CO</option>
                      <option value="AZ">AZ</option>
                      <option value="CA">CA</option>
                      <option value="NY">NY</option>
                      <option value="FL">FL</option>
                      <option value="IL">IL</option>
                      <option value="WA">WA</option>
                    </select>
                  </div>
                </div>
                <div className="form-row two-col">
                  <div className="form-group">
                    <label htmlFor="shipping_zip">ZIP Code</label>
                    <input
                      id="shipping_zip"
                      type="text"
                      value={shippingForm.zip}
                      onChange={(e) => setShippingForm({ ...shippingForm, zip: e.target.value })}
                      placeholder="79401"
                    />
                  </div>
                </div>
              </div>
            </section>
            )}

            {false}

            {false}

            <div className="checkout-card">
              <h3>Payment</h3>
              <label htmlFor="billing_email" style={{ display: 'block', fontWeight: 600, margin: '0.5rem 0 0.35rem 0' }}>Email for receipt</label>
              <input
                id="billing_email"
                type="email"
                className="checkout-email-input"
                value={billingEmail}
                onChange={(e) => setBillingEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
              {emailError && <small style={{ color: '#b91c1c' }}>{emailError}</small>}
              <button type="button" className="checkout-btn" onClick={handleStripeCheckout}>
                Pay with Card (Stripe)
              </button>
              <small style={{ color: '#000000', display: 'block', marginTop: '0.5rem' }}>
                This will create a test Payment Intent for now.
              </small>
            </div>
          </div>

          <aside className="cart-summary">
            <div className="order-summary">
              <h3>Order Summary</h3>
              <div className="cart-items" style={{ maxHeight: '220px', overflow: 'auto' }}>
                {items.map(item => (
                  <div key={item.cartId} className="cart-item" style={{ gridTemplateColumns: '60px 1fr auto', padding: '0.75rem' }}>
                    <div className="cart-item-image" style={{ width: '60px', height: '60px' }}>
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="cart-item-details">
                      <div className="cart-item-title" style={{ fontSize: '1rem' }}>{item.title}</div>
                      <div className="cart-item-meta" style={{ fontSize: '0.85rem' }}>Size: {item.size}{item.color ? ` • ${item.color}` : ''}</div>
                    </div>
                    <div className="cart-item-total">${(item.price * item.quantity).toFixed(2)}</div>
                  </div>
                ))}
              </div>

              <div className="summary-line">
                <span>Subtotal:</span>
                <span>${totals.subtotal}</span>
              </div>
              <div className="summary-line">
                <span>Shipping:</span>
                <span>${totals.shipping}</span>
              </div>
              <div className="summary-line">
                <span>Tax (8.25%):</span>
                <span>${totals.tax}</span>
              </div>
              <div className="summary-line total">
                <span>Total:</span>
                <span>${totals.total}</span>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  )
}

export default CheckoutPage
